import { ShopwareProduct } from '@services/types/Shopware';
import { useEffect, useState } from 'react';
import StorefrontApiService from '@services/StorefrontApiService';
import Link from 'next/link';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from '@tools/i18n';

interface ProductBundleProps {
    product: ShopwareProduct;
}

const useStyles = makeStyles({
    productBundleItem: {
        display: 'grid',
        gridTemplateColumns: 'max-content max-content',
        maxWidth: 300,
        gap: 8,
        fontWeight: 300,
        '& a': {
            color: 'inherit',
            textDecoration: 'inherit',
        }
    },
}, { name: 'product-bundles' });

export default function ProductBundle({ product }: ProductBundleProps) {
    const classes = useStyles();
    const [members, setMember] = useState<Array<{ qty: number, uuid: string }>>([]);
    const [products, setProducts] = useState<Array<ShopwareProduct>>([]);
    const {t} = useTranslation('product-info');

    useEffect(() => {
        // @ts-ignore
        const members = product?.customFields?.struct_member_uuids;
        if (Array.isArray(members)) {
            const formatted = members.map(item => {
                item.uuid = item.uuid?.replaceAll('-', '');
                return item;
            });

            setMember(formatted);

            const api = new StorefrontApiService();
            api.getProductByIds(formatted.map(item => item.uuid)).then((res) => {
                if (res.status === 'success' && Array.isArray(res.products)) {
                    setProducts(res.products);
                }
            });
        }
        // @ts-ignore
    }, [product.id]);

    function renderList() {
        if (!products.length) {
            return members.map((item) => {
                return <div className={'placeholder'}></div>;
            });
        }

        return products.map((item) => {
            const url = item?.seoUrls?.[0]?.seoPathInfo || `detail/${item.id}`;
            return <div className={classes.productBundleItem}>
                <span>{members.find(m => m.uuid === item.id)?.qty}x</span>
                {/** @ts-ignore */}
                <Link href={`/${url}`}>
                    <a>{item.name}</a>
                </Link>
            </div>;
        });
    }

    if (!members.length) {
        return null;
    }

    return <section>
        {t('product-info:bundle-title')}
        {renderList()}
    </section>;
}
